import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './containers/App';
import 'font-awesome/css/font-awesome.min.css'
import Login from './containers/login/login';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
